<template>
    <tr>
        <td>
            <b>{{ item.name }}</b>
        </td>
        <td>
            {{ item.articleNr }}
        </td>
        <td>{{ item.price }} €</td>
        <td align="center">
            <a @click="addToCart"><i v-if="loading" class="fa fa-spin fa-spinner"></i><i v-else class="fa fa-shopping-cart" aria-hidden="true"></i></a>
        </td>
        <td align="center">
            <a @click="remove"><i class="fa fa-times" aria-hidden="true"></i></a>
        </td>
    </tr>
</template>

<script>
export default {
    props: {
        item: {
            required: true
        }
    },
    data() {
        return {
            loading: false
        }
    },

    methods: {
        remove() {
            new Form({
                rowId: this.item.rowId
            })
            .post('/api/favoriten/remove')
            .then((response) => {
                App.event.fire('favoriten.updated', response);
            })
        },

        addToCart() {
            this.loading = true;
            new Form({
                pid: this.item.id,
                qty: 1
            })
            .post('/api/cart/add')
            .then((response) => {
                App.event.fire('cart.item.inserted', response.item);
                App.event.fire('cart.updated', response.data);
                this.loading = false;
            })
        }
    }
}
</script>

